import { StorageService } from './../../services/storage.service';
import { Component } from '@angular/core';
import { AdModel } from '../../core/models/ad.model';
import { AdImgViewComponent } from '../ad-img-view/ad-img-view.component';
import { AdApiService } from '../../services/ad-api.service';
import { ActivatedRoute } from '@angular/router';
import { AdVideoViewComponent } from '../ad-video-view/ad-video-view.component';
import { AdMediaViewComponent } from '../ad-media-view/ad-media-view.component';
declare global {
  interface Window {
    // Android bridge added via addJavascriptInterface("AndroidBridge", ...)
    AndroidBridge?: { onVarChange: (name: string, valueJson: string) => void };
    // iOS WKWebView bridge
    webkit?: { messageHandlers?: { iosBridge?: { postMessage: (msg: any) => void } } };
  }
}

@Component({
  selector: 'AMore-sdk-ad-container',
  imports: [AdImgViewComponent, AdVideoViewComponent, AdMediaViewComponent],
  templateUrl: './ad-container.component.html',
  styleUrl: './ad-container.component.scss'
})
export class AdContainerComponent {

  public adOnChange: AdModel = {} as AdModel;
  public adData: any = {} as any;
  public type: any = { type: '', index: 0 };
  public types: any[] = [];
  public currentAd: number = 0;
  private transactionId: string = '';

  public viewWidth: number = 0;
  public viewHeight: number = 0;

  private oldProggress: number = 0;
  private timeoutCutoffTime: number = 0;
  private addCompletedFlag: boolean = false;

  // Optional function you might hook/observe from native
  public state: any = {
  };
  someFunc = (msg: string) => {
    // console.log('someFunc called with', msg);
    // return Echo: ${msg};
    return this.adOnChange
  };

  constructor(private _AdApiService: AdApiService, private _StorageService: StorageService, private _ActivatedRoute: ActivatedRoute) {
    // Expose something on window if you plan to wrap/observe it natively
    (window as any).adOnChange = this.adOnChange;
    (window as any).someFunc = this.someFunc;
    this.transactionId = Math.random().toString(36).substring(2, 9) + Date.now();
    if (this._ActivatedRoute.snapshot.params['apiKey']) {
      this._StorageService.apiKey = this._ActivatedRoute.snapshot.params['apiKey'];
      this.viewHeight = this._ActivatedRoute.snapshot.queryParams['view_height'] ? parseInt(this._ActivatedRoute.snapshot.queryParams['view_height']) : 300;
      this.viewWidth = this._ActivatedRoute.snapshot.queryParams['view_width'] ? parseInt(this._ActivatedRoute.snapshot.queryParams['view_width']) : 300;

      this.state = {
        publisherId: this._ActivatedRoute.snapshot.queryParams['publisherId'],
        placementId: this._ActivatedRoute.snapshot.queryParams['placementId'],
        adUnitId: this._ActivatedRoute.snapshot.queryParams['adUnitId'],
        ... this._ActivatedRoute.snapshot.queryParams,
        allowedSizes: [
          this.viewWidth + 'x' + this.viewHeight
        ]
      };
      this.getAdsData();
    }
  }

  private getAdsData() {

    // this.changeAction( {action: 'on_loading', data : {}});
    this._AdApiService.getDeliver(this.state).subscribe({
      next: (res: any) => {
        if (res) {
          if (res && !res.errorCode && res.success) {
            this.adData = res;
            // console.log('Ad Data:', this.adData);

            // TODO 
            // adData.ads[0].creative.timeoutPercentage countdown (percentage)

            if (res.ads && res.ads.length > 0) {
              res.ads.forEach((ad: any, i: number) => {
                this.types.push({ type: ad.creative.type, index: i });
              });
              this.type = this.types[0];
              ///////////////
              // calculate cutoff time of the last ad
              // calculate timeout cutoff time for all ads (5s for each ad * timeout percentage)
              // - 5s for each ad except the last one7
              //////////////
              this.timeoutCutoffTime = ((5 * this.adData.ads.length) * (this.adData.ads[0].creative.timeoutPercentage / 100)) - ((5 * this.adData.ads.length - 1));

              this.changeAction({ action: 'on_ad_started', progress: this.oldProggress, data: { ...this.adData, ads: [this.adData.ads[this.currentAd]] } });
            }
          } else {
            this.changeAction({ action: 'on_ad_error', progress: this.oldProggress, data: { status_code: res.errorCode ? res.errorCode : '600', message: res.errorMessage ? res.errorMessage : 'error' } })
          }
        }
      },
      error: (err: any) => {
        this.changeAction({ action: 'on_ad_error', progress: this.oldProggress, data: { status_code: err.status ? err.status : '500', message: err.message } })
      },
      complete: () => {
      }
    });
  }

  changeAction(event: any) {
    if ((event.action === 'on_ad_skip' || event.action === 'on_next_ad' || event.action === 'on_ad_completed') && this.currentAd < this.types.length - 1) {
      this.currentAd++;
      this.type = this.types[this.currentAd];
      this.oldProggress += event.progress;

      this.sendEventToNative({ action: 'on_next_ad', progress: this.oldProggress, data: {} });
      this.sendEventToNative({ action: 'on_ad_started', progress: this.oldProggress, data: { ...this.adData, ads: this.adData.ads[this.currentAd] } });

      if (event.action === 'on_ad_completed') {
        return;
      }
    } else {
      event.progress += this.oldProggress;
      this.sendEventToNative(event);
    }

    //completed after the cutofftime of the last ad (5s static for the ad)
    if (this.currentAd === this.types.length - 1 && event.progress >= 5 && !this.addCompletedFlag) {
      this.addCompletedFlag = true;
      setTimeout(() => {
        this.sendEventToNative({ action: 'on_ad_completed', progress: this.oldProggress + event.progress, data: { ...this.adData } });
      }, this.timeoutCutoffTime * 1000);
    }

  }

  sendEventToNative(event: any) {

    this.adOnChange = { ...event, session_id: this._ActivatedRoute.snapshot.queryParams['sessionId'], ad_unit_id: this._ActivatedRoute.snapshot.queryParams['adUnitId'], timestamp: Date.now(), transaction_id: this.transactionId };
    (window as any).adOnChange = this.adOnChange;
    const payload = { event: 'var:adOnChange', valueJson: this.adOnChange };

    // console.log('Ad Event:', payload);
    console.log('Ad Event:', payload.valueJson.action);


    // Prefer iOS if present
    if (window.webkit?.messageHandlers?.iosBridge) {
      window.webkit.messageHandlers.iosBridge.postMessage(payload);
      return;
    }

    // Fallback to Android if present
    if (window.AndroidBridge?.onVarChange) {
      window.AndroidBridge.onVarChange('adOnChange', JSON.stringify(this.adOnChange));
    }

  }

  // Rotate the ad container
  // reposition it to top-left corner
  rotate(degree: number) {
    const container = document.querySelector('.ad-container') as HTMLElement;
    if (container) {
      container.style.transformOrigin = `${this.viewHeight}px 0px`;
      container.style.transform = `rotate(${degree}deg)`;
      if (degree < 0) {
        container.style.translate = `-${this.viewHeight}px ${this.viewHeight}px`;
      }else if (degree > 0) {
        container.style.translate = `0px ${this.viewHeight}px`;
      } else {
        container.style.translate = `0px 0px`;
      }
    }
  }
}
